import { __exportAll } from "./_virtual/_rolldown/runtime.js";
import "./starbucks_merchant_id.js";
//#region src/starbucks_merchant_id_helper.ts
var starbucks_merchant_id_helper_exports = /* @__PURE__ */ __exportAll({ name: () => name });
function name(merchantId) {
	switch (merchantId) {
		case "starbucks-merchant-id": return "Starbucks";
		case "97035900006": return `Kowalski's (${merchantId})`;
		case "97400802647": return `Villa Group JFK (${merchantId})`;
		case "97026601001": return `HMS Host (${merchantId})`;
		case "97400705279": return `Chapman University (${merchantId})`;
		case "97400705311": return `Florida State University (${merchantId})`;
	}
}
//#endregion
export { name, starbucks_merchant_id_helper_exports };

//# sourceMappingURL=starbucks_merchant_id_helper.js.map